import { getSiteBrand } from "@/lib/siteHosts";

const brandName = () => getSiteBrand().name;

export const MARGIN_THESIS = {
  tag: "SOURCE ISOLATION PROTOCOL",
  status: "WHOLESALE COST: CLASSIFIED",
  headline: "Your clients never discover the wholesale cost.",
  headlineAccent: "You remain the sole provider.",
  get insight() {
    return `Strict source isolation keeps ${brandName()} invisible. End clients see a neutral, unbranded utility while your agency keeps the entire margin spread.`;
  },
};

export const MARGIN_SCAN = [
  {
    value: "0",
    label: "Brand Leaks",
    get sub() {
      return `${brandName()} footprint`;
    },
  },
  { value: "100%", label: "Siloed", sub: "per-client env" },
  { value: "$140–400+", label: "Margin Kept", sub: "monthly spread" },
];

export const MARGIN_ZONES = [
  {
    id: "client",
    label: "CLIENT VIEW",
    title: "Neutral, unbranded surface",
    items: ["Anonymous system domain", "Own data streams only", "Zero upstream links"],
    tone: "visible",
  },
  {
    id: "agency",
    label: "YOUR AGENCY",
    title: "Sole technology provider",
    items: ["Full client relationship", "Wholesale dashboard hidden", "Entire markup retained"],
    tone: "protected",
  },
  {
    id: "wholesale",
    label: "WHOLESALE CORE",
    title: "Infrastructure source",
    get items() {
      return [`${brandName()} platform`, "Raw API costs", "Deployment telemetry"];
    },
    tone: "redacted",
  },
];

export const MARGIN_POINTS = [
  {
    layer: "L1",
    title: "Neutral Domain Redirection",
    tagline: "Anonymous routing layer",
    get description() {
      return `If you choose to grant your end clients direct access to monitor their conversation logs, calendar states, or CRM telemetry, they are routed to a completely anonymized, unbranded system domain. Zero links, footprints, or mentions of ${brandName()}.`;
    },
  },
  {
    layer: "L2",
    title: "Siloed Client Environments",
    tagline: "Per-client sandbox wall",
    description:
      "Every deployment slot operates inside a strictly sandboxed environment. Your clients only see their own data streams and automated calendars, while your core wholesale dashboard remains hidden.",
  },
  {
    layer: "L3",
    title: "Risk-Free Arbitrage",
    tagline: "Margin vault lock",
    description:
      "Because the infrastructure feels like an independent corporate utility, you can confidently maintain your $140 to $400+ monthly markup. Your clients get booked appointments; you keep the entire margin spread without interference.",
  },
];
